// extracted by mini-css-extract-plugin
module.exports = {"menu":"Subcategory_menu__acrmO","subMenu":"Subcategory_subMenu__1SmEj"};